export default __webpack_public_path__ + "40deaf5cafe88e13ef406c8085113105.png";